
import InsightTab from '../../atoms/insightTab/view'
import InsightTabGroup from '../../molecules/insightTab/view'
import './style.css'

const InsightsGroup = ({ children, id = 'insights-group', showTabs = true }) => {
    return (
        <div id={id} className='group'>
            {showTabs && (
                <InsightTabGroup id={id}>
                    <InsightTab>Dia</InsightTab>
                    <InsightTab>Semana</InsightTab>
                    <InsightTab>Mes</InsightTab>
                </InsightTabGroup>
            )}
            <div className='group-content'>
                {children}
            </div>
        </div>
    )
}

export default InsightsGroup
